import { Component, OnInit } from '@angular/core';
import { CodigoInvitacionService } from '../../services/services.index';
import { CodigoInvitacion } from '../../models/codigoInvitacion';
import { User } from '../../models/user.model';

declare var swal: any;
declare var $;

@Component({
  selector: 'app-codigos-invitacion',
  templateUrl: './codigos-invitacion.component.html',
  styles: []
})
export class CodigosInvitacionComponent implements OnInit {

  desde: number = 0;
  codigosInvitacion: CodigoInvitacion[];
  siguienteDisable: boolean = false;
  anteriorDisable: boolean = true;
  totalRegistros: number;
  usuarioMostrar: User;

  hideModal2: string = 'hide-modal';

  loading: boolean = true;

  constructor(public _codigoInvitacionService: CodigoInvitacionService) { }

  ngOnInit() {
    this.cargarCodigos();
    $(document).ready(function() {
      $('body').tooltip({ selector: '[data-toggle=tooltip]' });
  });
  }

  cargarCodigos() {
    this.loading = true;
    this._codigoInvitacionService.getCodigosInvitacion(this.desde).subscribe((data: any) => {

      this.codigosInvitacion = data.codigosInvitacion;
      this.totalRegistros = data.total;

      this.loading = false;

      // Habilito/inhabilito boton de siguiente.
      if ((this.desde + 10) >= this.totalRegistros) {
        this.siguienteDisable = true;
      } else {
        this.siguienteDisable = false;
      }
    });
  }

  anterior() {
    this.desde -= 10;
    this.cargarCodigos();

    if ((this.desde - 10) < 0) {
      this.anteriorDisable = true;
    }
    if ((this.desde + 10) >= this.totalRegistros) {
      this.siguienteDisable = true;
    } else {
      this.siguienteDisable = false;
    }
  }

  siguiente() {
    this.desde = this.desde + 10;
    this.cargarCodigos();

    if ((this.desde + 10) >= this.totalRegistros) {
      this.siguienteDisable = true;
    }

    if ((this.desde - 10) < 0) {
      this.anteriorDisable = true;
    } else {
      this.anteriorDisable = false;
    }
  }

  generarCodigo() {
    this.loading = true;
    this._codigoInvitacionService.crearCodigoInvitacion().subscribe(data => {
      swal('Código Generado', 'Código: ' + data.codigo, 'success');
      this.loading = false;
      this.cargarCodigos();
    });
  }

  borrarCodigo(codigo: CodigoInvitacion) {
    swal({
      title: '¿Esta seguro?',
      text: '¿Esta seguro que desea borrar este código?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        this.loading = true;
        this._codigoInvitacionService.borrarCodigoInvitacion(codigo).subscribe(data => {
          swal('Código Borrado', 'Código borrado satisfactoriamente', 'success');
          this.loading = false;
          this.cargarCodigos();
        });
      }
    });

  }

  verUsuarioCodigo(codigo: any, i: number) {
    $('#usuarioTooltip_' + i).tooltip('hide');
    this.usuarioMostrar = codigo.uid;
    this.showUsuarioModal();
  }

  hideModalMethod2() {
    this.hideModal2 = 'hide-modal';
  }

  showUsuarioModal() {
    this.hideModal2 = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/codigos-invitacion/codigos-invitacion.component.ts